import { BaseRankedUserState, RankedUserStateType } from './BaseRankedUserState.ts';
export class RankedLockedState extends BaseRankedUserState {
    finishedPlacementGames() {
        return this.numberOfGamesPlayed >= this.requiredNumberOfGames;
    }
    getEndGameScreenText() {
        const remainingGames = this.requiredNumberOfGames - this.numberOfGamesPlayed;
        const title = {
            key: 'strings:game.endGame.rankedUpdate.lockedTitle',
            options: {
                gamesPlayedCount: this.numberOfGamesPlayed,
                requiredGamesCount: this.requiredNumberOfGames
            }
        };
        const description = {
            key: 'strings:game.endGame.rankedUpdate.lockedDescription',
            options: {
                count: remainingGames
            }
        };
        return {
            title: title,
            description: description
        };
    }
    getEndGameData() {
        return this.defaultEndGameData;
    }
    getFindGamePopupStatusText() {
        return {
            key: 'strings:colonistCommon.rankedState.gamesPlayed',
            options: {
                gamesPlayedCount: this.numberOfGamesPlayed,
                count: this.requiredNumberOfGames
            }
        };
    }
    static deserialize(data) {
        const newRankedState = new RankedLockedState(data.numberOfGamesPlayed, data.requiredNumberOfGames);
        return newRankedState;
    }
    constructor(numberOfGamesPlayed, requiredNumberOfGames){
        super(), this.type = RankedUserStateType.RankedLocked;
        this.numberOfGamesPlayed = numberOfGamesPlayed;
        this.requiredNumberOfGames = requiredNumberOfGames;
        this.defaultEndGameData = {
            amount: '-',
            highest: false
        };
    }
}
